import React, {Component} from 'react';

import ToggleInput from "../../../../../components/ToggleInput/toggleInput";
import formatters from "../../../../../utils/formatters";

export default class TripExit extends Component {

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;

        let pending =  <span className={"grey-text"}>-</span>;
        let exit_weight = trip.exit_weight ? trip.exit_weight : pending;
        let scale_out_datetime = pending;
        if(trip.scale_out_datetime){
            scale_out_datetime = formatters.datetimeFormat(trip.scale_out_datetime);
        }

        let manifiestoBody = (
            <div className={"waiting-continer valign-wrapper w100"} style={{height: 100}}>
                <p className={"w100 center"}>
                    Este producto no requiere control de manifiesto
                    <br />
                    <i className="material-icons">more_horiz</i>
                </p>
            </div>
        );

        if(trip.product.needs_manifiesto){
            if(trip.manifiesto){
                manifiestoBody = (
                    <div className={"row margin-top-10"}>
                        <div className={"col s6"}>
                            <ToggleInput selected={trip.product.needs_manifiesto }
                                         name={'¿Necesita Manifiesto?'} />
                        </div>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Manifiesto</label>
                            <p className={"field-p"}>{trip.manifiesto ? trip.manifiesto : '-'}</p>
                        </div>
                    </div>
                );
            }else{
                manifiestoBody = (
                    <div className={"waiting-continer valign-wrapper w100"} style={{height: 100}}>
                        <p className={"w100 center"}>
                            Aguardando control de manifiesto
                            <br />
                            <i className="material-icons">more_horiz</i>
                        </p>
                    </div>
                );
            }
        }

        let form = (
            <div className={"row no-padding thin-row trip-form"}>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Manifiesto</h4>
                    </div>
                    {manifiestoBody}
                </div>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Balanza de Salida</h4>
                    </div>
                    <div className={"row no-margin margin-top-10"}>
                        <div style={{borderLeft: '1px solid #404040', paddingLeft: 20}}>
                            {trip.exit_weight && trip.scale_out_datetime &&
                            <div className={"row"}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Peso Salida</label>
                                    <p className={"field-p"}>{exit_weight}</p>
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Fecha de Salida</label>
                                    <p className={"field-p"}>{scale_out_datetime}</p>
                                </div>
                            </div>
                            }

                            {(!trip.exit_weight || !trip.scale_out_datetime) &&
                            <div className={"waiting-continer valign-wrapper w100"} style={{height: 100}}>
                                <p className={"w100 center"}>
                                    Aguardando pesaje
                                    <br />
                                    <i className="material-icons">more_horiz</i>
                                </p>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );

        if(this.props.boxed){
            return (
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Egreso</div>
                    {form}
                </div>
            );
        }

        return form;
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/InternalTrips/Trip/Done/TripExit.js